import { IEnrolModel } from 'models/enrol.model'
import api from '..'

export interface ICreateRequestParams {
  courseId: number
  note: string
}

const createRequest = (enrol: ICreateRequestParams) => {
  return api.post<IEnrolModel>('enrols/request', enrol)
}

export default createRequest
